import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
import VueMoment from 'vue-moment';
Vue.use(VueMoment);
import Sticky from 'vue-sticky-directive';
Vue.use(Sticky);
import Vuex from 'vuex';
Vue.use(Vuex);

import VuexPersist from 'vuex-persist';

Vue.config.productionTip = false;

import filters from './filters';
for (let name in filters) {
	Vue.filter(name, filters[name]);
}
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBIswHRc1E1cJ0rOY7JpZIo-KPCh9OMgJY',
		libraries: 'places' // This is required if you use the Autocomplete plugin
		// OR: libraries: 'places,drawing'
		// OR: libraries: 'places,drawing,visualization'
		// (as you require)

		//// If you want to set the version, you can do so:
		// v: '3.26',
	}
});

fetch(window.webpackHotUpdate ? '/config.dev.json' : '/config')
	.then(r => r.json())
	.then(config => {
		window.config = config;
		config.css.variables.forEach(rule => {
			document.documentElement.style.setProperty(rule.name, rule.value);
		});
		const vuexPersist = new VuexPersist({
			key: config.keyword,
			storage: window.localStorage
		});
		store.plugins = [vuexPersist.plugin];

		new Vue({
			router,
			store: new Vuex.Store(store),
			i18n,
			vuetify,
			render: h => h(App)
		}).$mount('#app');
	});
